import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";

const ViewCampaign = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Campaign Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/marketing")}>
            Marketing Suite
          </button>{" "}
          - Campaign Details
        </p>
      </div>
   
      <div className="cards">
       
          <div className="view_page">
            {/* ================= BASIC INFO ================= */}
            <div className="section_box">
              <h2>Basic Information</h2>
              <div className="gap_p">
                <div className="w_33">
                  <h6>Campaign Name</h6>
                  <p>Diwali Mega Sale</p>
                </div>

                <div className="w_33">
                  <h6>Campaign Type</h6>
                  <p>Discount Code</p>
                </div>

                <div className="w_33">
                  <h6>Status</h6>
                  <SwitchToggle />
                </div>

                <div className="w_33">
                  <h6>Start Date</h6>
                  <p>20 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>End Date</h6>
                  <p>30 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>Created Date</h6>
                  <p>10 November 2025</p>
                </div>
                <div className="w_33">
                  <h6>Clicks</h6>
                  <p>50</p>
                </div>
                <div className="w_33">
                  <h6>Conversions</h6>
                  <p>15</p>
                </div>
              </div>
            </div>

            {/* ================= DISCOUNT CODE ================= */}
            <div className="section_box">
              <h2>Discount Code Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Apply Discount On</h6>
                  <p>Category</p>
                </div>

                <div className="w_33">
                  <h6>Selected Categories</h6>
                  <p>Electronics, Clothing</p>
                </div>

                <div className="w_33">
                  <h6>Discount Type</h6>
                  <p>Percentage</p>
                </div>

                <div className="w_33">
                  <h6>Discount Value</h6>
                  <p>15%</p>
                </div>

                <div className="w_33">
                  <h6>Minimum Purchase</h6>
                  <p>₹500</p>
                </div>

                <div className="w_33">
                  <h6>Usage Limit</h6>
                  <p>100</p>
                </div>
              </div>
            </div>

            {/* ================= FLASH SALE ================= */}
            <div className="section_box">
              <h2>Flash Sale Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Flash Sale Applies On</h6>
                  <p>Specific Products</p>
                </div>

                <div className="w_33">
                  <h6>Flash Products</h6>
                  <p>Laptop, Drone</p>
                </div>

                <div className="w_33">
                  <h6>Flash Start Date</h6>
                  <p>20 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>Flash End Date</h6>
                  <p>25 November 2025</p>
                </div>
              </div>
            </div>

            {/* ================= BUNDLE DEAL ================= */}
            <div className="section_box">
              <h2>Bundle Deal Details</h2>

              {/* Buy X Get Y */}
              <div className="sub_section">
                <h3>Buy X Get Y Free</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Buy Quantity</h6>
                    <p>2</p>
                  </div>

                  <div className="w_33">
                    <h6>Get Quantity</h6>
                    <p>1</p>
                  </div>

                  <div className="w_33">
                    <h6>Eligible Products</h6>
                    <p>T-shirt, Jeans</p>
                  </div>

                  <div className="w_33">
                    <h6>Free Product Same?</h6>
                    <p>Yes</p>
                  </div>
                </div>
              </div>

              {/* Combo Offer */}
              <div className="sub_section">
                <h3>Combo Offer</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Products</h6>
                    <p>Laptop, Mouse</p>
                  </div>

                  <div className="w_33">
                    <h6>Bundle Price</h6>
                    <p>₹45,000</p>
                  </div>

                  <div className="w_33">
                    <h6>Original Total</h6>
                    <p>₹52,000</p>
                  </div>
                </div>
              </div>

              {/* Quantity Discount */}
              <div className="sub_section">
                <h3>Quantity Based Discount</h3>
                <div className="gap_p">
                  <div className="w_33">
                    <h6>Minimum Quantity</h6>
                    <p>3</p>
                  </div>

                  <div className="w_33">
                    <h6>Discount Type</h6>
                    <p>Percentage</p>
                  </div>

                  <div className="w_33">
                    <h6>Discount Value</h6>
                    <p>10%</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= FREE SHIPPING ================= */}
            <div className="section_box">
              <h2>Free Shipping Details</h2>

              <div className="gap_p">
                <div className="w_33">
                  <h6>Apply On</h6>
                  <p>Location</p>
                </div>

                <div className="w_33">
                  <h6>Locations</h6>
                  <p>India, USA</p>
                </div>

                <div className="w_33">
                  <h6>Start Date</h6>
                  <p>21 November 2025</p>
                </div>

                <div className="w_33">
                  <h6>End Date</h6>
                  <p>30 November 2025</p>
                </div>
              </div>
            </div>

            {/* ================= PREMIUM TOOLS ================= */}
            <div className="section_box">
              <h2>Premium Tools Details</h2>

              {/* Banner Tools */}
              <div className="sub_section">
                <h3>Homepage Banner / Slider / Category Banner</h3>
                <div className="gap_p">
                  <div className="vew_img w_50 no_radius">
                    <h6>Banner Uploaded</h6>
                    <figure>
                      <img alt="user" src="/static/images/placeholder.png" />
                    </figure>
                  </div>

                  <div className="w_50">
                    <h6>Amount</h6>
                    <p>AED 5000</p>
                  </div>
                </div>
              </div>

              {/* Featured Product Tag */}
              <div className="sub_section">
                <h3>Featured Product Tag</h3>
                <div className="gap_p">
                  <div className="w_50">
                    <h6>Selected Product</h6>
                    <p>Laptop</p>
                  </div>

                  <div className="w_50">
                    <h6>Amount</h6>
                    <p>AED 5000</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
     
      </div>
    </>
  );
};
export default ViewCampaign;
